import { createFileRoute } from '@tanstack/react-router'

import { CasePage, NewCaseDialog } from '@/modules/tools/bankruptcy'

export const Route = createFileRoute(
  '/_authenticated/tools/bankruptcy-screener/$filingId',
)({
  staticData: { title: 'Case' },
  component: CaseRoute,
})

function CaseRoute() {
  const { filingId } = Route.useParams()

  return (
    <>
      <CasePage filingId={Number(filingId)} />
      <NewCaseDialog />
    </>
  )
}
